"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _loggerFactory = _interopRequireDefault(require("@salesforce/pwa-kit-runtime/utils/logger-factory"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/*
 * Copyright (c) 2024, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

const logger = Object.freeze((0, _loggerFactory.default)({
  packageName: 'pwa-kit-react-sdk'
}));
var _default = exports.default = logger;